import React, { FC } from 'react';

const REAGroupLogo: FC = () => (
  <svg
    width="84px"
    height="20px"
    fill="none"
    viewBox="0 0 101 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="m2.1311e-4 11.933c-0.0391 6.6288 5.3072 12.032 11.936 12.066 6.6289 0.0391 12.03-5.3098 12.064-11.939 0.0339-6.6262-5.3072-12.027-11.936-12.061h-0.0678c-6.5949-0.0026067-11.962 5.3281-11.996 11.933z"
        fill="#E4002B"
      />
      <path
        d="m16.196 18.995h-8.3936c-0.66471 0-1.2043-0.5396-1.2043-1.2043v-4.9344h-1.0062c-0.48746 0-0.92277-0.292-1.1105-0.7403-0.18768-0.451-0.08602-0.9645 0.25807-1.3112l6.4046-6.4359c0.2242-0.22417 0.5344-0.35451 0.8524-0.35451s0.6282 0.13034 0.8524 0.35451l6.4046 6.4359c0.3441 0.3467 0.4458 0.8602 0.2581 1.3112-0.1877 0.4509-0.623 0.7403-1.1105 0.7403h-1.0009v4.9344c0 0.6647-0.5396 1.2043-1.2043 1.2043zm-4.1968-13.938c-0.0443 0-0.0834 0.01564-0.1147 0.04692l-6.4046 6.4359c-0.04692 0.0469-0.05996 0.1147-0.03389 0.1746 0.02607 0.06 0.08341 0.0991 0.14858 0.0991h1.5275c0.28674 0 0.52134 0.2346 0.52134 0.5213v5.4558c0 0.0887 0.07299 0.1617 0.16161 0.1617h8.3936c0.0886 0 0.1616-0.073 0.1616-0.1617v-5.4558c0-0.2867 0.2346-0.5213 0.5213-0.5213h1.5276c0.0651 0 0.1225-0.0391 0.1485-0.0991 0.0261-0.0599 0.0105-0.1277-0.0338-0.1746l-6.4099-6.4359c-0.0313-0.03128-0.0704-0.04692-0.1147-0.04692z"
        fill="#fff"
      />
      <path
        d="m34.494 17.457-2.7839-3.8318h-1.4076v3.8318h-2.0358v-10.479h4.1915c2.3799 0 3.8475 1.2721 3.8475 3.3834 0 1.5432-0.9436 2.6641-2.4242 3.0837l3.068 4.0117h-2.4555zm-4.1941-8.6672v3.128h2.0514c1.1365 0 1.8117-0.5239 1.8117-1.5562 0-1.0635-0.6882-1.5718-1.8117-1.5718h-2.0514z"
        fill="currentColor"
      />
      <path
        d="m45.198 8.7898h-5.2994v2.4242h4.6556v1.7804h-4.6556v2.651h5.2994v1.8116h-7.3509v-10.479h7.3509v1.8116z"
        fill="currentColor"
      />
      <path
        d="m54.099 17.457-1.0036-2.7109h-3.9204l-1.0036 2.7109h-2.1271l4.116-10.479h1.9915l4.1316 10.479h-2.1844zm-4.3115-4.387h2.6954l-1.3477-3.652-1.3477 3.652z"
        fill="currentColor"
      />
      <path
        d="m69.216 11.688c0.0443 0.2841 0.06 0.5396 0.06 0.7951 0 3.3105-2.2183 5.1534-4.9736 5.1534-2.9221 0-5.2447-2.1714-5.2447-5.4245 0-3.2532 2.2027-5.4246 5.2447-5.4246 1.9185 0 3.8814 1.0036 4.6738 3.042l-1.7517 0.92795c-0.5839-1.3946-1.5588-2.0984-2.9221-2.0984-1.783 0-3.102 1.3346-3.102 3.5504 0 2.2026 1.4077 3.5503 3.102 3.5503 1.6917 0 2.6666-0.915 2.8621-2.4112h-2.8621v-1.6631h4.9136v0.0026z"
        fill="currentColor"
      />
      <path
        d="m74.729 9.5614v2.0671h-0.8081c-0.8993 0-1.5432 0.6439-1.5432 1.783v4.0456h-1.9341v-7.7158h1.9341v1.1078c0.4353-0.8993 1.1391-1.2877 1.9472-1.2877h0.4041z"
        fill="currentColor"
      />
      <path
        d="m75.057 13.591c0-2.3825 1.6917-4.0299 3.97-4.0299 2.3069 0 4.0013 1.6474 4.0013 4.0299 0 2.3982-1.6918 4.0456-4.0013 4.0456-2.2756 0-3.97-1.65-3.97-4.0456zm5.9928 0c0-1.4675-0.868-2.3069-2.0228-2.3069-1.1391 0-1.9915 0.8394-1.9915 2.3069 0 1.4832 0.855 2.3382 1.9915 2.3382 1.1548-0.0026 2.0228-0.855 2.0228-2.3382z"
        fill="currentColor"
      />
      <path
        d="m84.108 14.355v-4.6138h1.9472v4.4939c0 1.1548 0.6151 1.6787 1.4519 1.6787 0.855 0 1.4545-0.5239 1.4545-1.6787v-4.4939h1.9472v4.6138c0 2.0672-1.4545 3.2819-3.4017 3.2819-1.9316 0-3.3991-1.2147-3.3991-3.2819z"
        fill="currentColor"
      />
      <path
        d="m100.11 13.591c0 2.3226-1.4671 4.0456-3.4612 4.0456-1.1548 0-1.9185-0.5552-2.3981-1.319v3.6703h-1.9316v-10.247h1.9316v1.1078c0.4796-0.7481 1.2433-1.2877 2.3981-1.2877 1.9941 0 3.4612 1.723 3.4612 4.0299zm-1.9754 0.0131c0-1.4832-0.8081-2.3226-1.9472-2.3226-1.1521 0-1.9628 0.8394-1.9628 2.3226s0.8081 2.3069 1.9628 2.3069c1.1365 0.0026 1.9472-0.8237 1.9472-2.3069z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default REAGroupLogo;
